import _extends from "@babel/runtime-corejs3/helpers/extends";
import _CloseIcon from "@sk/icons/lib/CloseIcon";
import React from 'react';
import AntdModal from 'antd/lib/modal';
var MiddleModal = /*#__PURE__*/React.memo(props => {
  return /*#__PURE__*/React.createElement(AntdModal, _extends({}, props, {
    width: 680,
    closeIcon: /*#__PURE__*/React.createElement(_CloseIcon, null),
    maskClosable: false,
    wrapClassName: "middle-modal"
  }));
});
export default MiddleModal;